import axios from 'axios';

// const sendLog = async (type, data) => {
//   axios({
//     method: 'post',
//     url: process.env.REACT_APP_LOCAL_API + '/logger',
//     headers: {
//       'X-CompanyID': 'magex',
//       'X-Token': process.env.REACT_APP_X_TOKEN
//     },
//     data: {
//       type: type,
//       data: data
//     }
//   });
// }

const localRequest = async function (options) {
  let client = axios.create({
    baseURL: process.env.REACT_APP_LOCAL_API,
    headers: {
      'X-CompanyID': 'magex',
      'X-Token': process.env.REACT_APP_X_TOKEN,
    },
  });

  const machineMode = localStorage.getItem('testMode') === 'false' ? true : false;
  // if (machineMode) {
  const onSuccess = function (response) {
    // console.debug('Request Successful!', response);
    return response;
  };

  const onError = function (error) {
    console.error('Request Failed:', error.config);

    if (error.response) {
      // Request was made but server responded with something
      // other than 2xx
      console.error('Status:', error.response.status);
      console.error('Data:', error.response.data);
      console.error('Headers:', error.response.headers);
    } else {
      // Something else happened while setting up the request
      // triggered the error
      console.error('Error Message:', error.message);
    }

    return Promise.reject(error);
  };

  return client(options).then(onSuccess).catch(onError);
  // }
};

export default localRequest;
